module.exports = __webpack_public_path__ + "media/images/parallax/illustration-do-background-49d909ee9c707eed205963ba2daecc8c.png";